// extracted by mini-css-extract-plugin
export default {"cmsPagesSeoContentWrapper":"CmsPagesSeoEditModal_cmsPagesSeoContentWrapper__Mk8Aq","seoContentLocked":"CmsPagesSeoEditModal_seoContentLocked__Y4EAf"};